import { FC } from "react";
import { Modal, Container, Button, Col, Row } from "react-bootstrap";
import Loading from "../../../../../components/loading";
import { ModalEmailConfirmationInterface } from "./indexModel";

import './styles.scss';

const ModalEmailConfirmation: FC<ModalEmailConfirmationInterface> = (props) => {
  return (
    <Modal className="modalEmailConfirmation" show={props.showModal} onHide={() => props.hide()} aria-labelledby="" centered={true}>
      { props.isLoading && <Loading visibility={props.isLoading} noBootstrap={true} customStyle={{ position: 'absolute' }} /> }
      <Modal.Header style={{ padding: '1rem 1rem 0rem 1rem' }} closeButton>
        <span>Reenviar e-mail de ativação</span>
      </Modal.Header>
      <Modal.Body>
        <Container>
          {
            props.currentUser?.email_confirmation_at &&
            <span className="modalInfo">
              A conta <strong>{props.currentUser?.email}</strong> já está ativada.
            </span>
          }
          {
            !props.currentUser?.email_confirmation_at &&
            <span className="modalInfo">
              Deseja enviar o email de ativação de conta para <strong>{props.currentUser?.email}</strong>?
            </span>
          }
          <Row className="mt-3">
            <Col md={5} className="">
              <Button size='lg' className="buttonWhite2" style={{ width: '100%' }} onClick={() => props.hide()} >Cancelar</Button>
            </Col>
            <Col></Col>
            <Col md={5} className="d-flex justify-content-end align-self-end">
              <Button 
                onClick={() => props.submit()} 
                disabled={props.isLoading || !!props.currentUser?.email_confirmation_at} 
                size='lg' className="buttonBlue2WithoutBold" 
                style={{ width: '100%' }}
              >Enviar e-mail</Button>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
}

export default ModalEmailConfirmation;
